export default "__VITE_ASSET__Cs5yvCa9__"